export default __webpack_public_path__ + "static/media/CheckIcon.123898e9.svg";